import styled from 'styled-components';

export const StyledItemsPopup = styled.div`
  .items-popup-tooltip {
    background-color: var(--surface);
    width: 810px;
    border-radius: 1rem;
    color: var(--ink);
    &:after {
      display: none;
    }
  }
`;

export const StyledItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  :not(:last-child) {
    border-bottom: 1px solid rgba(9,15,56,0.15);
  }
  padding: 0.5rem 0;
`;
